import axios from 'axios';

const api = axios.create({
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
  },
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers['Authorization'] = `Bearer ${token}`;
  }
  return config;
});

export const setupAxiosInterceptors = (handleSessionExpiry) => {
  api.interceptors.response.use(
    (response) => response,
    (error) => {
      if (error.response && error.response.status === 401) {
        const currentPath = window.location.pathname;
        const isAuthPath = currentPath === "/login" || currentPath === "/parent-login";
        const reqUrl = error.config?.url || "";
        const isLoginRequest = reqUrl.includes("/login") || reqUrl.includes("/auth");

        // Only trigger session expiry modal/redirect if 401 occurs outside login requests/pages
        if (!isAuthPath && !isLoginRequest) {
          localStorage.clear();
          sessionStorage.clear();

          if (handleSessionExpiry) {
            handleSessionExpiry();
          }

          window.location.href = "/login";
        }
      }
      return Promise.reject(error);
    }
  );
};

export async function get(url, options = {}) {
  return api.get(url, options).then((res) => res);
}

export async function post(url, data) {
  return api.post(url, data).then((res) => res);
}

export async function post2(url, data) {
  const headers = {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  };
  return api.post(url, data, headers).then((res) => res);
}

export async function put(url, data) {
  return api.put(url, data).then((res) => res);
}

export async function put2(url, data) {
  const headers = {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  };
  return api.put(url, data, headers).then((res) => res);
}

export async function del(url, data) {
  return api.delete(url, { data }).then((res) => res);
}

export default api;